import { certificatesFormTranslationKeys } from '../../../../../translations';

export const CERTIFICATE_VALIDATION_MESSAGES = {
   passwordRequired: certificatesFormTranslationKeys.invalidPasswordErrorMessage,
};
